import { Component, ErrorInfo, ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can log the error to an analytics provider here
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="mx-auto max-w-3xl min-h-screen flex flex-col justify-center items-start">
          <h1 className="text-4xl font-bold text-gray-900">
            Oops! Something went wrong
          </h1>

          {this.state.error && (
            <div className="mt-4 p-4 bg-red-50 border-l-4 border-red-400 text-red-700 w-full">
              <p className="font-mono text-sm break-all">
                {this.state.error.toString()}
              </p>
            </div>
          )}

          <Link
            to="/"
            className="font-medium mt-6 text-lg text-blue-500 hover:text-blue-400"
          >
            Go home
          </Link>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
